// extracted by mini-css-extract-plugin
export default {"IconButton":"group-header-expansion-button-module__IconButton--w0GA9"};